import { find, includes, isArray, isEmpty, isEqual, isNil } from "lodash";
import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { ORIENTATION_H, ORIENTATIONS } from "./ChartResolver";

function StackedBarChart(props) {
  const { colors: defaultColors, data } = props;

  const orientation = data?.valor?.orientation || ORIENTATION_H;
  const chartData = data?.valor?.def || null;
  const colors = data?.valor?.colors || defaultColors;

  const layout = includes(ORIENTATIONS, orientation)
    ? orientation
    : ORIENTATION_H;

  if (
    isNil(data) ||
    isNil(chartData) ||
    !isArray(chartData) ||
    isEmpty(chartData)
  ) {
    return null;
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ResponsiveContainer width="100%" height="90%">
        <BarChart width={900} height={900} data={chartData} layout={layout}>
          <CartesianGrid strokeDasharray="3 3" />
          {layout === ORIENTATION_H ? (
            <>
              <XAxis dataKey="name" type="category" />
              <YAxis type="number" />
            </>
          ) : (
            <>
              <XAxis type="number" />
              <YAxis dataKey="name" type="category" />
            </>
          )}

          <Tooltip labelStyle={{ color: "grey" }} />
          <Legend />
          {Object.keys(chartData[0] || {}).map((key, index) => {
            if (key !== "name") {
              const colorToUse = isEqual(defaultColors, colors)
                ? colors[index % colors.length]
                : find(colors, { key })?.color || colors[index % colors.length];
              return (
                <Bar key={key} dataKey={key} stackId="a" fill={colorToUse} />
              );
            }
            return null;
          })}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default StackedBarChart;
